module.exports = "/_next/static/images/logo-21b3c4265d4053c41f2ca4b0af4cb290.svg";